export default __webpack_public_path__ + "static/media/bannerethnix.593fcf58.png";